import $ from 'jquery';
import { restoreScrollPos, saveScrollPos } from 'utils';
import debounce from 'debounce';

$(() => {
    restoreScrollPos();
    $(window).on('scroll', debounce(saveScrollPos, 200));
});
